import {useWakeLock as useWakeLockHook} from 'react-screen-wake-lock';
import {useEffect} from 'react';

const useWakeLock = (): void => {
    const {request, release} = useWakeLockHook();

    useEffect(() => {
        const handleVisibilityChange = (): void => {
            if (document.hidden) {
                release();
            } else {
                request('screen');
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        request('screen');

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            release();
        };
    }, [request, release]);
};

export default useWakeLock;
